
import React, { useState, useEffect } from 'react'
import './index.less'

export default function Slider(props) {
  const [ifon, setIfon] = useState({
    value: props.defaultValue,
    step: React.createRef(),
    isPress: false,
    isMove: false,
    pressX: null,
    pressY: null,
    width: 0,
    x: 0,
    Width: null,
    text: ''
  })

  useEffect(() => {
    const func = () => {
      const stepIfon = ifon.step.current.getBoundingClientRect()
      let value = null
      if (props.defaultValue < props.minValue) {
        value = props.minValue < 0 ? 0 : props.minValue
      }
      if (props.defaultValue > props.maxValue) {
        value = props.maxValue
      }

      if (!value) {
        value = props.defaultValue
      }

      const width = stepIfon.width / props.maxValue * value

      setIfon({
        ...ifon,
        Width: stepIfon.width,
        width,
        text: Math.ceil(value)
      })
    }

    if (!ifon.isMove) {
      func()
    }
  }, [props.defaultValue, props.maxValue])

  useEffect(() => {
    const func = (e) => {
      if (ifon.isPress) {
        handleMove(e, ifon, setIfon, props)
      }
    }
    const func1 = (e) => {
      if (ifon.isPress) {
        handleUp(e, ifon, setIfon, props)
      }
    }

    window.addEventListener('mousemove', func)
    window.addEventListener('mouseup', func1)
    return () => {
      window.removeEventListener('mousemove', func)
      window.removeEventListener('mouseup', func1)
    }
  })

  return (<div className='Slider'>
    {props.children && <div className='Slider_titleArea'>
      {props.children}
    </div>}

    <div className='Slider_main'>
      <div className='main_step' ref={ifon.step}>
        <p className='step_step' style={{ width: ifon.width + ifon.x }}>
          <i className='step_icon' onMouseDown={({ clientX, clientY }) => {
            setIfon({
              ...ifon,
              isPress: true,
              pressX: clientX,
              pressY: clientY
            })
          }}></i>
        </p>
      </div>
    </div>
    <div className='Slider_inputArea'>
      <input className='inputArea_input' value={ifon.text} onChange={(e) => {
        let text = e.target.value === '' ? 0 : parseFloat(e.target.value)
        if (isNaN(text)) {
          return
        }
        if (text < 0) {
          text = 0
        }
        if (text > props.maxValue) {
          text = props.maxValue
        }
        setIfon({
          ...ifon,
          text,
          width: handleValue(text, ifon, setIfon, props)
        })
        props.change && props.change(text)
      }} />
      <div className='inputArea_icon'>
        <i className='icon' onClick={() => {
          if (ifon.text <= props.minValue) {
            return
          }
          setIfon({
            ...ifon,
            text: ifon.text - 1,
            width: handleValue(ifon.text - 1, ifon, setIfon, props)
          })
          props.change && props.change(ifon.text - 1)
        }}><svg viewBox='64 64 896 896' focusable='false' data-icon='up' width='10px' height='1em' fill='#47657a' aria-hidden='true'><path d='M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'></path></svg></i>
        <i className='icon' onClick={() => {
          if (ifon.text >= props.maxValue) {
            return
          }
          setIfon({
            ...ifon,
            text: ifon.text + 1,
            width: handleValue(ifon.text + 1, ifon, setIfon, props)
          })
          props.change && props.change(ifon.text + 1)
        }}><svg viewBox='64 64 896 896' focusable='false' data-icon='down' width='10px' height='1em' fill='#47657a' aria-hidden='true'><path d='M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'></path></svg></i>
      </div>
    </div>
  </div>)
}

function handleMove({ clientX, clientY }, ifon, setIfon, props) {
  const x = clientX - ifon.pressX

  if ((x + ifon.width >= ifon.Width) || (x + ifon.width <= 0)) {
    return
  }

  const value = (x + ifon.width) / ifon.Width * props.maxValue

  setIfon({
    ...ifon,
    isMove: true,
    x,
    text: Math.ceil(value)
  })

  props.change && props.change(Math.ceil(value))
}

function handleUp(e, ifon, setIfon, props) {
  setIfon({
    ...ifon,
    isPress: false,
    isMove: false,
    pressX: null,
    pressY: null,
    width: ifon.width + ifon.x,
    x: 0
  })
}

function handleValue(value, ifon, setIfon, props) {
  const width = ifon.Width / props.maxValue * value
  return width
}

Slider.defaultProps = {
  defaultValue: 0,
  maxValue: 100,
  minValue: 0,
  children: null,
  isInput: true
}
